/* ============================================
   ROOTD HOME DECOR — THEME JS
   ============================================ */

'use strict';

/* === STICKY HEADER ===
   The header uses CSS `position: sticky`, which reserves its own
   space in normal flow — no manual body offset needed. */

/* === MOBILE NAVIGATION === */
(function () {
  const openBtn  = document.querySelector('.nav-toggle');
  const closeBtn = document.querySelector('.mobile-nav__close-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const overlay  = document.getElementById('nav-overlay');

  if (!openBtn || !mobileNav) return;

  const openNav = () => {
    mobileNav.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    openBtn.setAttribute('aria-expanded', 'true');
  };

  const closeNav = () => {
    mobileNav.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
    openBtn.setAttribute('aria-expanded', 'false');
  };

  openBtn.addEventListener('click', openNav);
  closeBtn && closeBtn.addEventListener('click', closeNav);
  overlay && overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeNav();
  });
})();

/* === PRODUCT IMAGE GALLERY === */
(function () {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery) return;

  const thumbnails = gallery.querySelectorAll('.product-gallery__thumb');
  const mainBtn = gallery.querySelector('.product-gallery__main');
  const mainImage = gallery.querySelector('.product-gallery__main img');
  const counter = gallery.querySelector('[data-gallery-counter]');
  const total = thumbnails.length;

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      const alt = thumb.dataset.alt;
      const zoomSrc = thumb.dataset.zoomSrc;

      if (mainImage && src) {
        mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        if (alt) mainImage.alt = alt;
        if (zoomSrc) mainImage.dataset.zoomSrc = zoomSrc;
      }

      thumbnails.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      if (counter && total) counter.textContent = thumb.dataset.index + ' / ' + total;
    });
  });

  // Lightbox
  const lightbox = document.getElementById('product-lightbox');
  const lightboxImage = document.getElementById('product-lightbox-image');
  if (mainBtn && lightbox && lightboxImage) {
    const openLightbox = () => {
      const zoomSrc = mainImage ? (mainImage.dataset.zoomSrc || mainImage.src) : '';
      lightboxImage.src = zoomSrc;
      lightboxImage.alt = mainImage ? mainImage.alt : '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-open');
    };
    const closeLightbox = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
    };

    mainBtn.addEventListener('click', openLightbox);
    lightbox.querySelectorAll('[data-lightbox-close]').forEach((el) => el.addEventListener('click', closeLightbox));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });
  }
})();

/* === ADD TO CART (AJAX) === */
(function () {
  const forms = document.querySelectorAll('[data-add-to-cart-form]');

  forms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const btn = form.querySelector('[data-add-to-cart-btn]');
      const formData = new FormData(form);

      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.loadingText || 'Adding...';
      }

      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (!res.ok) throw new Error('Add to cart failed');

        const data = await res.json();
        updateCartCount();

        if (btn) {
          btn.textContent = btn.dataset.addedText || 'Added!';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = btn.dataset.defaultText || 'Add to cart';
          }, 2000);
        }
      } catch (err) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.defaultText || 'Add to cart';
        }
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      const cart = await res.json();
      const counters = document.querySelectorAll('[data-cart-count]');
      counters.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch (e) {
      // fail silently
    }
  }
})();

/* === PRODUCT VARIANT SELECTOR === */
(function () {
  const selectors = document.querySelectorAll('[data-variant-selector]');

  selectors.forEach((selector) => {
    const options = selector.querySelectorAll('[data-variant-option]');
    const variantsJson = document.querySelector('[data-variants-json]');

    if (!variantsJson) return;

    let variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    options.forEach((opt) => {
      opt.addEventListener('click', () => {
        const optionName = opt.dataset.optionName;
        const optionValue = opt.value || opt.dataset.value;

        const siblings = selector.querySelectorAll(`[data-option-name="${optionName}"]`);
        siblings.forEach((s) => s.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        updateSelectedVariant(selector, variants);
      });
    });
  });

  function updateSelectedVariant(selector, variants) {
    const selectedOptions = [];
    const groups = selector.querySelectorAll('[data-option-group]');

    groups.forEach((group) => {
      const selected = group.querySelector('.is-selected');
      if (selected) selectedOptions.push(selected.dataset.value);
    });

    const matched = variants.find((v) => {
      // Match against either v.options array or v.option1/option2/option3
      if (Array.isArray(v.options) && v.options.length) {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      }
      return selectedOptions.every((sel, i) => v['option' + (i + 1)] === sel);
    });

    if (matched) {
      const priceEl = document.querySelector('[data-product-price]');
      const variantInput = document.querySelector('[name="id"]');
      const addBtn = document.querySelector('[data-add-to-cart-btn]');

      if (priceEl && matched.price) {
        priceEl.textContent = formatMoney(matched.price);
      }
      if (variantInput) variantInput.value = matched.id;
      if (addBtn) {
        addBtn.disabled = !matched.available;
        const atcLabel = matched.available
          ? addBtn.dataset.defaultText || 'Add to cart'
          : addBtn.dataset.soldOutText || 'Sold out';
        const atcPriceEl = addBtn.querySelector('[data-atc-price]');
        if (atcPriceEl) {
          addBtn.childNodes[0].textContent = atcLabel + ' ';
          atcPriceEl.textContent = '· ' + formatMoney(matched.price);
        } else {
          addBtn.textContent = atcLabel;
        }
      }

      // Swap product gallery image to variant's featured image if it has one
      if (matched.featured_image && matched.featured_image.src) {
        const mainImage = document.querySelector('.product-gallery__main img, #product-main-image');
        const src = matched.featured_image.src.split('?')[0];
        if (mainImage) {
          // Build width-suffixed Shopify image URLs
          const buildUrl = (w) => src.replace(/(\.[^.\/]+)$/, `_${w}x$1`);
          mainImage.src = buildUrl(900);
          mainImage.srcset = `${buildUrl(600)} 600w, ${buildUrl(900)} 900w, ${buildUrl(1200)} 1200w`;
          if (matched.featured_image.alt) mainImage.alt = matched.featured_image.alt;
        }
        // Activate matching thumbnail
        const thumbs = document.querySelectorAll('.product-gallery__thumb');
        thumbs.forEach((t) => {
          const tSrc = (t.dataset.src || '').split('?')[0].replace(/_\d+x(\.[^.\/]+)$/, '$1');
          if (tSrc && src.indexOf(tSrc.split('/').pop().split('.')[0]) !== -1) {
            thumbs.forEach((x) => x.classList.remove('is-active'));
            t.classList.add('is-active');
          }
        });
      }

      // Notify bundle picker (and any other listeners) that the variant changed
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: matched }
      }));
    }
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  }
})();

/* === QUANTITY STEPPER === */
(function () {
  document.querySelectorAll('.quantity-selector').forEach((el) => {
    const input = el.querySelector('input[type="number"]');
    const decreaseBtn = el.querySelector('[data-decrease]');
    const increaseBtn = el.querySelector('[data-increase]');

    if (!input) return;

    decreaseBtn && decreaseBtn.addEventListener('click', () => {
      const min = parseInt(input.min) || 1;
      const val = parseInt(input.value) || 1;
      if (val > min) {
        input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    increaseBtn && increaseBtn.addEventListener('click', () => {
      const max = parseInt(input.max) || 99;
      const val = parseInt(input.value) || 1;
      if (val < max) {
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
